import './App.css';
import Login from './pages/Login/Login';
import Register from './pages/Register/Register';
import Home from './pages/home/Home';
import DashBoard from './pages/dashboards/Dashboard';
import ProtectedRoute from './routes/ProtectedRoute';
import { BrowserRouter, Routes as Wrapper, Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';

function App() {

  const history = createBrowserHistory()
  return (
    <BrowserRouter history={history} >
      <div className="App">

        <Wrapper>

            <Route exact path="/"  Component={Home}/>

            <Route path="/login" Component={Login}/>
            <Route path="/register" Component={Register}/>

            <Route path="/dashboard" element={
                <ProtectedRoute>
                    <DashBoard/>
                </ProtectedRoute>
            } />
            
        </Wrapper>
      </div>
        
    </BrowserRouter>
    


      


    
  );
}

export default App;
